import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "~/v2/components/ui/card"
import VaasAiMetadataFields from "~/v2/components/vaas/vaas-ai-metadata-fields"

const VaasLessonMetadataSection = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Lesson metadata</CardTitle>
      </CardHeader>
      <CardContent>
        <VaasAiMetadataFields />
      </CardContent>
    </Card>
  )
}

export default VaasLessonMetadataSection
